import { Box, Carousel, Image, useMediaQueryContext } from "@drone-js/core";
import { usePropertySelectionViewModelValue } from "apps/propertySelection/propertySelectionViewModelAtom";
import { useMemo, useState } from "react";

const learnMoreImageSrc = {
    desktop: {
        rakuten: "https://cdn6.agoda.net/images/homesOnboarding/import-rakuten-desktop.svg",
        rakutenOyado: "https://cdn6.agoda.net/images/property-onboarding/Rakuten%20Oyado%20Carousel%20Desktop%20V2.svg",
        airbnb: "https://cdn6.agoda.net/images/homesOnboarding/import-airbnb-desktop.svg",
        bcom: "https://cdn6.agoda.net/images/homesOnboarding/import-bcom-desktop.svg",
    },
    mobile: {
        rakuten: "https://cdn6.agoda.net/images/homesOnboarding/import-rakuten-mobile.svg",
        rakutenOyado: "https://cdn6.agoda.net/images/property-onboarding/Rakuten%20Oyado%20Carousel%20Mobile.svg",
        airbnb: "https://cdn6.agoda.net/images/homesOnboarding/import-airbnb-mobile.svg",
        bcom: "https://cdn6.agoda.net/images/homesOnboarding/import-bcom-mobile.svg",
    },
};

const UrlImage = ({
    isMobile = false,
    showRakutenImport,
    showRakutenOyadoImport,
}: {
    isMobile?: boolean;
    showRakutenImport: boolean;
    showRakutenOyadoImport: boolean;
}) => {
    const [carouselIndex, setCarouselIndex] = useState(0);
    const images = useMemo(() => {
        const sources = learnMoreImageSrc[isMobile ? "mobile" : "desktop"];

        if (!showRakutenImport) {
            return [sources.airbnb, sources.bcom];
        }

        const rakutenImage = showRakutenOyadoImport ? sources.rakutenOyado : sources.rakuten;
        return [rakutenImage, sources.airbnb, sources.bcom];
    }, [isMobile, showRakutenImport, showRakutenOyadoImport]);

    return (
        <Carousel
            display="single"
            loading="lazy"
            pageControl="below"
            previousNavAttributes={{
                "data-element-name": "carousel-buttons",
                "data-value": carouselIndex.toString(),
            }}
            nextNavAttributes={{
                "data-element-name": "carousel-buttons",
                "data-value": carouselIndex.toString(),
            }}
            onPageChange={(index) => setCarouselIndex(index)}
        >
            {images.map((src) => (
                <Image key={src} objectFit="cover" loading="immediate" src={src} alt="import-example" />
            ))}
        </Carousel>
    );
};

export const InputURLImage = () => {
    const { showRakutenImport, showRakutenOyadoImport } = usePropertySelectionViewModelValue();
    const { m: isMoreThanMobileSize } = useMediaQueryContext();
    return (
        <Box qM={{ pt: "32", maxWidth: "848px" }} pt="24">
            <UrlImage
                isMobile={!isMoreThanMobileSize}
                showRakutenImport={showRakutenImport}
                showRakutenOyadoImport={showRakutenOyadoImport}
            />
        </Box>
    );
};
